import type { TranslationMessages } from './types';

export const bugReport: TranslationMessages = {
  title: 'Báo cáo lỗi',
  description:
    'Giúp chúng tôi cải thiện bằng cách báo cáo lỗi. Bao gồm ảnh chụp màn hình và mô tả những gì đã xảy ra.',
  screenshot: 'Ảnh chụp màn hình',
  captureScreenshot: 'Chụp màn hình',
  capturing: 'Đang chụp...',
  uploadScreenshot: 'Tải lên ảnh chụp màn hình',
  drawCircle: 'Vòng tròn',
  drawArrow: 'Mũi tên',
  drawRectangle: 'Hình chữ nhật',
  drawCustom: 'Vẽ Hình dạng Tùy chỉnh',
  clearAnnotations: 'Xóa Tất cả Chú thích',
  removeAnnotation: 'Xóa chú thích này',
  zoomIn: 'Phóng to',
  zoomOut: 'Thu nhỏ',
  resetZoom: 'Đặt lại Thu phóng',
  annotationType: {
    circle: 'Khoanh tròn',
    rectangle: 'Khung',
    arrow: 'Mũi tên',
    custom: 'Tùy chỉnh',
  },
  descriptionLabel: 'Điều gì đã xảy ra?',
  descriptionPlaceholder: 'Mô tả lỗi bạn gặp phải...',
  expectationLabel: 'Bạn mong đợi điều gì?',
  expectationPlaceholder: 'Mô tả những gì bạn mong đợi sẽ xảy ra...',
  submit: 'Gửi báo cáo',
  submitting: 'Đang gửi...',
  revealSensitiveData: 'Hiển thị Dữ liệu Nhạy cảm',
  hideSensitiveData: 'Ẩn Dữ liệu Nhạy cảm',
  screenshotEmpty: 'Chụp màn hình trả về dữ liệu trống',
  captureFailed: 'Không thể chụp màn hình',
  descriptionRequired: 'Vui lòng cung cấp mô tả',
  sentSuccessfully: 'Đã gửi báo cáo lỗi thành công',
  submitFailed: 'Không thể gửi báo cáo lỗi',
  reauthTitle: 'Yêu cầu Xác thực lại',
  reauthDescription:
    'Vui lòng nhập mật khẩu của bạn để hiển thị dữ liệu nhạy cảm trong ảnh chụp màn hình. Điều này được yêu cầu cho mục đích bảo mật.',
};
